export type FeedCategory = '现场直击' | '红毯生图' | '综艺名场面' | '热剧动态';

export interface NewsItem {
  id: string;
  title: string;
  excerpt: string;
  category: FeedCategory | '娱乐热点';
  tag: string;
  date: string;
  views: string;
  author: string;
  image: string;
  featured?: boolean;
}

export const CATEGORIES: Array<FeedCategory> = ['现场直击', '红毯生图', '综艺名场面', '热剧动态'];

export const TICKER_ITEMS: string[] = [
  '星光电影节红毯落幕，生图秒出圈',
  '新一季《今夜开麦》官宣，后台花絮先行曝光',
  '头部热剧《月落长街》首播即登热搜',
  '音乐节现场路透：天气虽热人气不减',
  '大热综艺录制现场名场面合集更新中',
];

export const NAV_LINKS = [
  { label: '现场直击', href: '#live' },
  { label: '热点热榜', href: '#hot' },
  { label: '生图画廊', href: '#gallery' },
  { label: '名场面', href: '#moment' },
  { label: '吃瓜小贴士', href: '#faq' },
];

export const FEED_ITEMS: NewsItem[] = [
  {
    id: 'f1',
    title: '星光电影节红毯生图精选：镁光灯下的真实状态一览',
    excerpt: '红毯现场从头到尾全程跟拍，生图直出不修不磨皮。这一次到场阵容相当整齐，几套礼服在自然光下究竟撑不撑得住，原片会给出最诚实的答案。',
    category: '红毯生图',
    tag: '红毯',
    date: '2026-09-09',
    views: '12.8万',
    author: '前排老狗',
    featured: true,
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20red%20carpet%20moment%20with%20warm%20spotlights%20and%20film%20cameras%2C%20elegant%20silhouette%20walking%20under%20bright%20stage%20lights%2C%20cream%20and%20vermilion%20editorial%20tone%2C%20glamorous%20festival%20night%2C%20high%20detail%20photojournalism%20style&width=800&height=500&seq=feed-redcarpet-01&orientation=landscape',
  },
  {
    id: 'f2',
    title: '顶流爱豆音乐节舞台直击：高强度唱跳 40 分钟全程在线',
    excerpt: '傍晚的体育馆座无虚席，开场十分钟观众席的应援灯海就已连成一片。全程稳定输出，几套走位卡点干净利落，中场环节还下场和前排观众互动，现场气氛拉到顶。',
    category: '现场直击',
    tag: '舞台',
    date: '2026-09-08',
    views: '9.6万',
    author: '夜场蹲点员',
    image: 'https://readdy.ai/api/search-image?query=Lively%20indoor%20concert%20stage%20with%20golden%20and%20warm%20lighting%2C%20energetic%20performer%20silhouette%20with%20light%20sticks%20in%20the%20dark%20crowd%2C%20dynamic%20concert%20atmosphere%2C%20editorial%20photography%2C%20warm%20amber%20tone&width=800&height=500&seq=feed-concert-02&orientation=landscape',
  },
  {
    id: 'f3',
    title: '《月落长街》首播口碑观察：服化道被赞，剧情走向成最大悬念',
    excerpt: '年度古装大剧《月落长街》昨晚首播。开局前两集铺垫了多条人物线，画面质感和服装细节普遍被认可。真正把人钓上钩的，是片尾那场戛然而止的雨戏。',
    category: '热剧动态',
    tag: '热剧',
    date: '2026-09-07',
    views: '21.3万',
    author: '追更小分队',
    image: 'https://readdy.ai/api/search-image?query=Atmospheric%20period%20drama%20scene%20with%20misty%20rain%2C%20ancient%20Chinese%20architecture%20and%20figure%20in%20flowing%20robe%2C%20moody%20cinematic%20lighting%2C%20warm%20tonal%20film%20grain%2C%20editorial%20premiere%20stills%20style&width=800&height=500&seq=feed-drama-03&orientation=landscape',
  },
  {
    id: 'f4',
    title: '《今夜开麦》首期名场面：主持人接梗失灵，全场笑到失控',
    excerpt: '新综艺首期一上来就贡献了整季最能打的临场发挥。嘉宾和主持人之间三次接梗失误反而促成了教科书级的名场面，弹幕实时炸开，剪辑组估计连夜加班。',
    category: '综艺名场面',
    tag: '综艺',
    date: '2026-09-06',
    views: '15.1万',
    author: '镜头补位员',
    image: 'https://readdy.ai/api/search-image?query=Fun%20variety%20show%20studio%20scene%20with%20colorful%20set%20design%20and%20hosts%20laughing%2C%20bright%20warm%20stage%20lights%2C%20lively%20entertainment%20broadcast%20mood%2C%20editorial%20photography%2C%20high%20energy%20composition&width=800&height=500&seq=feed-variety-04&orientation=landscape',
  },
  {
    id: 'f5',
    title: '品牌发布会后台生图：妆造环节意外出圈，状态比精修更能打',
    excerpt: '品牌活动后台跟拍到一组极其真实的妆造花絮。打光没有进场时，几位嘉宾的皮肤状态和举手投足反而更松弛自然，网友直呼这才是想看的路透本透。',
    category: '红毯生图',
    tag: '后台',
    date: '2026-09-05',
    views: '6.8万',
    author: '化妆间观察员',
    image: 'https://readdy.ai/api/search-image?query=Backstage%20beauty%20preparation%20scene%20with%20vanity%20mirror%20lights%20and%20makeup%20artists%2C%20candid%20celebrity%20styling%20moment%2C%20warm%20soft%20lighting%2C%20natural%20behind%20the%20scenes%20photography%2C%20editorial%20fashion%20tone&width=800&height=500&seq=feed-backstage-05&orientation=landscape',
  },
  {
    id: 'f6',
    title: '爆款悬疑剧定档：双男主人设反差拉满，预告片信息量爆炸',
    excerpt: '又一部压箱底的悬疑剧终于定档。从已释出的两版预告来看，双男主人设一冷一热反差极大，多线伏笔埋得很密。原著粉和路人观众都盯紧了开播日历。',
    category: '热剧动态',
    tag: '定档',
    date: '2026-09-04',
    views: '18.7万',
    author: '追更小分队',
    image: 'https://readdy.ai/api/search-image?query=Moody%20mystery%20thriller%20drama%20poster%20style%20with%20two%20characters%20in%20dim%20corridor%20light%2C%20tense%20shadow%20play%2C%20warm%20and%20dark%20cinematic%20tone%2C%20editorial%20key%20art%2C%20high%20contrast%20lighting&width=800&height=500&seq=feed-thriller-06&orientation=landscape',
  },
  {
    id: 'f7',
    title: '粉丝见面会现场直击：玩游戏环节笑点密集，互动福利拉满',
    excerpt: '城市巡回路演第二站结束。流程虽然紧凑，但互动环节的临场反应贡献了不少值得反复回看的片段。现场粉丝举牌花式整活，氛围轻松又热闹。',
    category: '现场直击',
    tag: '见面会',
    date: '2026-09-03',
    views: '7.9万',
    author: '前排老狗',
    image: 'https://readdy.ai/api/search-image?query=Cheerful%20fan%20meeting%20event%20with%20playful%20games%20on%20stage%20and%20excited%20audience%20holding%20signs%2C%20warm%20festive%20venue%20lighting%2C%20candid%20entertainment%20photography%2C%20lighthearted%20atmosphere&width=800&height=500&seq=feed-fanmeet-07&orientation=landscape',
  },
  {
    id: 'f8',
    title: '年度盛典后台花絮：上台前的最后一刻，紧张与松弛都被镜头记住',
    excerpt: '盛典颁奖间隙，镜头捕捉到后台通道里众生相：有人反复默念获奖感言，有人在角落补妆，也有前辈在开导紧张的后辈。这些没剪进正片的画面反而最有人味。',
    category: '综艺名场面',
    tag: '后台',
    date: '2026-09-02',
    views: '11.2万',
    author: '夜场蹲点员',
    image: 'https://readdy.ai/api/search-image?query=Candid%20backstage%20awards%20ceremony%20corridor%20scene%2C%20performers%20waiting%20with%20soft%20golden%20warm%20light%2C%20documentary%20style%20photojournalism%2C%20authentic%20emotional%20moment%2C%20editorial%20tone&width=800&height=500&seq=feed-award-08&orientation=landscape',
  },
  {
    id: 'f9',
    title: '新剧开机路透：横店片场偶遇全套古装造型，辨识度直接拉满',
    excerpt: '在影视基地蹲点偶遇一场夜戏。全副武装的古装造型隔着老远就能认出来，候场间隙还和现场工作人员说说笑笑。片场安保虽严，还是被长焦镜头记录到了。',
    category: '现场直击',
    tag: '路透',
    date: '2026-09-01',
    views: '8.3万',
    author: '化妆间观察员',
    image: 'https://readdy.ai/api/search-image?query=Historical%20drama%20film%20set%20at%20night%20with%20ancient%20costumes%20and%20studio%20lights%2C%20actors%20in%20flowing%20robes%20waiting%20between%20takes%2C%20warm%20practical%20set%20lighting%2C%20documentary%20behind%20the%20scenes%2C%20cinematic%20grain&width=800&height=500&seq=feed-onset-09&orientation=landscape',
  },
];

export const HOT_RANK = [
  { no: 1, title: '星光电影节红毯生图，谁的状态最能打？', heat: '98℃', cat: '红毯' },
  { no: 2, title: '《月落长街》首播口碑两极分化背后', heat: '94℃', cat: '热剧' },
  { no: 3, title: '音乐节现场亲测：音响和应援哪个更顶', heat: '91℃', cat: '现场' },
  { no: 4, title: '《今夜开麦》首期名场面弹幕考古', heat: '88℃', cat: '综艺' },
  { no: 5, title: '顶流舞台直拍 4K 版横空出世', heat: '85℃', cat: '舞台' },
  { no: 6, title: '品牌发布会后台生图全网求原片', heat: '82℃', cat: '后台' },
  { no: 7, title: '悬疑剧双男主预告逐帧解析', heat: '79℃', cat: '热剧' },
  { no: 8, title: '见面会游戏环节笑点合集冲上热门', heat: '76℃', cat: '现场' },
  { no: 9, title: '古装夜戏路透造型引热议', heat: '73℃', cat: '路透' },
  { no: 10, title: '年度盛典后台人情味片段刷屏', heat: '70℃', cat: '综艺' },
];

export const GALLERY = [
  { title: '红毯生图 · 墨绿缎面晚礼', desc: '自然光下缎面泛出温润光泽', image: 'https://readdy.ai/api/search-image?query=Full%20length%20red%20carpet%20fashion%20portrait%20in%20deep%20green%20satin%20evening%20gown%2C%20elegant%20pose%20under%20warm%20spotlight%2C%20cream%20backdrop%2C%20editorial%20glamour%20photography%2C%20sophisticated%20high%20fashion%20mood&width=600&height=760&seq=gal-gown-01&orientation=portrait' },
  { title: '生图直出 · 暖杏色西装', desc: '轻西装剪裁利落，状态松弛', image: 'https://readdy.ai/api/search-image?query=Contemporary%20fashion%20portrait%20in%20warm%20beige%20tailored%20suit%2C%20confident%20relaxed%20standing%20pose%2C%20soft%20studio%20lighting%2C%20minimal%20cream%20background%2C%20editorial%20street%20fashion%20photography&width=600&height=760&seq=gal-suit-02&orientation=portrait' },
  { title: '后台妆造 · 松弛瞬间', desc: '未进场的真实状态最动人', image: 'https://readdy.ai/api/search-image?query=Candid%20behind%20the%20scenes%20makeup%20room%20portrait%2C%20artist%20relaxing%20by%20vanity%20mirror%20with%20warm%20bulbs%2C%20natural%20everyday%20expression%2C%20soft%20golden%20light%2C%20documentary%20fashion%20photography&width=600&height=760&seq=gal-backstage-03&orientation=portrait' },
  { title: '舞台生图 · 高光一瞬', desc: '追光灯下的定格名场面', image: 'https://readdy.ai/api/search-image?query=Powerful%20stage%20performance%20moment%20with%20dramatic%20follow%20spotlight%20and%20dust%20particles%2C%20dynamic%20dance%20pose%2C%20warm%20golden%20stage%20light%2C%20concert%20photography%2C%20high%20energy%20editorial%20shot&width=600&height=760&seq=gal-stage-04&orientation=portrait' },
];

export const MOMENTS = [
  {
    tag: '接梗名场面',
    title: '主持人三次接梗失灵，笑到节目停录',
    views: '45.6万播放',
    duration: '02:41',
    image: 'https://readdy.ai/api/search-image?query=Comedic%20variety%20show%20moment%20with%20hosts%20laughing%20uncontrollably%20on%20a%20bright%20set%2C%20playful%20golden%20warm%20lighting%2C%20candid%20behind%20the%20scenes%20fun%2C%20broadcast%20still%20style&width=400&height=240&seq=mom-talk-01&orientation=landscape',
  },
  {
    tag: '舞台直拍',
    title: '顶流 4K 直拍全网首发，卡点零失误',
    views: '88.2万播放',
    duration: '03:58',
    image: 'https://readdy.ai/api/search-image?query=Close%20up%20performance%20shot%20of%20sharp%20dance%20moves%20in%20sync%20with%20music%2C%20vibrant%20warm%20stage%20lighting%2C%20concert%20video%20frame%2C%20dynamic%20energy%2C%20high%20quality%20broadcast&width=400&height=240&seq=mom-dance-02&orientation=landscape',
  },
  {
    tag: '后台人情',
    title: '前辈开导紧张后辈，通道里的暖光',
    views: '33.9万播放',
    duration: '01:26',
    image: 'https://readdy.ai/api/search-image?query=Warm%20supportive%20backstage%20moment%20of%20mentor%20encouraging%20nervous%20young%20performer%20in%20corridor%2C%20soft%20golden%20practical%20lighting%2C%20emotional%20documentary%20style%2C%20cinematic%20grain&width=400&height=240&seq=mom-backstage-03&orientation=landscape',
  },
  {
    tag: '游戏神回',
    title: '见面会游戏环节五连击，粉丝笑出眼泪',
    views: '27.4万播放',
    duration: '04:12',
    image: 'https://readdy.ai/api/search-image?query=Joyful%20fan%20game%20segment%20on%20stage%20with%20colorful%20props%20and%20laughing%20crowd%2C%20warm%20festive%20lights%2C%20candid%20entertainment%20broadcast%2C%20playful%20and%20bright&width=400&height=240&seq=mom-game-04&orientation=landscape',
  },
];

export const FAQS = [
  {
    q: '「生图」和「精修图」到底有什么区别？',
    a: '生图指现场直接拍出、未经磨皮调色处理的原始照片，更接近真实状态，所以常被用来判断艺人状态好不好、妆造上不上镜；精修图则经过后期润色，风格更统一。栏目里的红毯生图板块收录的多是前者。',
  },
  {
    q: '「路透」是什么意思？为什么会受关注？',
    a: '路透最初指拍摄或活动进行中流出的现场片段与照片，因为真实、即时而珍贵。公开场合的活动路透能让人第一时间看到造型与现场氛围，这也是明星吃瓜现场最受欢迎的内容类型之一。',
  },
  {
    q: '你们的内容来源可靠吗？会不会是炒作？',
    a: '我们只记录公开场合的现场见闻、活动报道与已官宣的动态，聚焦红毯、舞台、发布会等公开流程。涉及当事人主观状态时均保留客观口径，不做未经证实的揣测，也不发布针对具体个人的负面花边。',
  },
  {
    q: '视频片段和直播回放要去哪里看？',
    a: '本站会为每期「现场直击」与「名场面」整理文字综述并配上重点片段缩略导览，同时把活动时间轴列出来方便你按图索骥去官方渠道看完整直播回放，避免你在多平台来回翻找。',
  },
  {
    q: '为什么同一场活动会有不同版本的说法？',
    a: '娱乐现场鱼龙混杂，同一场活动不同机位、不同时段拍到的画面天然不同。我们尽量标注拍摄视角与时间点，也欢迎你在评论区补充现场视角，让信息在多方对照下更接近真实。',
  },
  {
    q: '如何第一时间收到最新瓜点的推送？',
    a: '你可以在页脚订阅「吃瓜速递」，留下常用邮箱后，我们会按频道把你关心的红毯、综艺与热剧动态汇总到一封邮件里，重要场次还会附带直播时间预告，不让你错过名场面。',
  },
];

export interface SidebarCard {
  title: string;
  desc: string;
  tag: string;
}